module.exports = __webpack_public_path__ + "static/media/Cloroplasto v6.acca9265.glb";